var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divider"},[_c('div',{staticClass:"line"}),(_vm.title!="")?_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]):_vm._e(),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }